"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var React = require("react");
var RowHeaderCell_1 = require("./RowHeaderCell");
var HeaderColumn_1 = require("./HeaderColumn");
var HeaderRow = /** @class */ (function (_super) {
    tslib_1.__extends(HeaderRow, _super);
    function HeaderRow() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.measuredHeaderWidths = {};
        _this.handleReportHeaderWidth = function (columnKey, width) {
            if (_this.props.measureColumnWidths) {
                _this.measuredHeaderWidths[columnKey] = Math.max(width, _this.measuredHeaderWidths[columnKey] || 0);
            }
        };
        return _this;
    }
    HeaderRow.prototype.componentWillMount = function () {
        this.measuredHeaderWidths = {};
    };
    HeaderRow.prototype.componentDidMount = function () {
        this.reportMeasuredColumnWidths();
    };
    HeaderRow.prototype.componentDidUpdate = function () {
        this.reportMeasuredColumnWidths();
    };
    HeaderRow.prototype.reportMeasuredColumnWidths = function () {
        if (this.props.measureColumnWidths && Object.keys(this.measuredHeaderWidths).length > 0) {
            var measuredHeaderWidths = tslib_1.__assign({}, this.measuredHeaderWidths);
            this.measuredHeaderWidths = {};
            this.props.measureColumnWidths(measuredHeaderWidths);
        }
    };
    HeaderRow.prototype.isColumnSelected = function (colIdx) {
        return !!this.props.selectionModel && this.props.selectionModel.isSelected({ colIdx: colIdx, colKey: this.props.cols[colIdx].dataKey, rowIdx: -1 });
    };
    HeaderRow.prototype.render = function () {
        var columnWidths = this.props.columnWidths || {};
        // tslint:disable-next-line
        var hcols = [];
        // Optionally show Select-All corner 'button'
        if (!!this.props.onRowHeaderCellClick && this.props.colStartIdx === 0) {
            hcols.push(RowHeaderCell_1.RowHeaderCell.element({
                key: "hcell",
                isSelected: false,
                onRowHeaderCellClick: this.props.onRowHeaderCellClick,
                rowType: RowHeaderCell_1.RowHeaderCell.RowType.Header,
                testId: 'hcell'
            }));
        }
        for (var colIdx = this.props.colStartIdx; colIdx <= this.props.colEndIdx; colIdx++) {
            var col = this.props.cols[colIdx];
            var shouldReportWidth = !col.preferredWidth && this.props.measuredColumnWidths[col.name] === undefined;
            hcols.push(HeaderColumn_1.HeaderColumn.element({
                key: col.name,
                col: col,
                colIdx: colIdx,
                isSelected: this.isColumnSelected(colIdx),
                showVerticalGridLines: this.props.showVerticalGridLines,
                sorted: this.props.sortKey === col.dataKey,
                sortAscending: this.props.sortAscending,
                reportWidthFn: shouldReportWidth ? this.handleReportHeaderWidth : undefined,
                width: shouldReportWidth ? undefined : columnWidths[col.name],
                minWidth: this.props.minColWidth,
                onColumnResize: this.props.onColumnResize,
                onHeaderClick: this.props.onHeaderClick,
                onHeaderDoubleClick: this.props.onHeaderDoubleClick,
                onHeaderContextMenu: this.props.onHeaderContextMenu
            }));
        }
        return (React.createElement("div", { "aria-rowindex": 1, className: 'tb-react-dg-hrow', role: 'row', style: { height: this.props.headerHeight, paddingLeft: this.props.leftMargin } },
            React.createElement("div", { className: 'tb-react-dg-hcols', style: { display: 'inline-block', height: '100%', marginLeft: -this.props.scrollLeft, whiteSpace: 'nowrap' } }, hcols)));
    };
    HeaderRow.displayName = 'DataGridHeaderRow';
    return HeaderRow;
}(React.PureComponent));
exports.HeaderRow = HeaderRow;
//# sourceMappingURL=HeaderRow.js.map